import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DocumentRowToolbar from "../../utils-components/document-row-toolbar.vue";
import DocumentPreviewModal from "@Shared/components/document-previewer/document-preview-modal.vue";
import { mapActions } from "vuex";
import { DOWNLOAD_DOCUMENT, RENAME_REQUEST_LIST_DOCUMENT, DELETE_DOCUMENT_FROM_REQUEST_CLASSIFICATION } from "../../../store/documents-actions";
import { openFileDialog } from "../../../../../../../../../shared/utils/utils";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DocumentRequestRow",
  components: {
    DocumentRowToolbar,
    DocumentPreviewModal
  },
  props: {
    sampleDocument: {
      type: Object,
      required: true
    },
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      editingFileName: false,
      downloading: false,
      deleting: false,
      loadingPreview: false,
      previewDocumentUrl: "",
      localFileName: ""
    };
  },
  computed: {
    documentRequestId() {
      return this.sampleDocument.documentRequestId;
    },
    createdAt() {
      return this.sampleDocument.createdAt;
    },
    documentNumber() {
      return this.sampleDocument.documentNumber;
    },
    documentId() {
      return this.sampleDocument.documentId;
    },
    fileName() {
      return this.sampleDocument.fileName;
    },
    fileNameWithoutExtension() {
      var _context;
      return _sliceInstanceProperty(_context = this.fileName.split(".")).call(_context, 0, -1).join(".");
    },
    fileExtension() {
      return this.fileName.split(".").pop();
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("DocumentsStore", [DOWNLOAD_DOCUMENT, RENAME_REQUEST_LIST_DOCUMENT, DELETE_DOCUMENT_FROM_REQUEST_CLASSIFICATION])), {}, {
    async handleDownloadDocument() {
      this.downloading = true;
      const {
        url
      } = await this.DOWNLOAD_DOCUMENT({
        clientUsername: this.clientUsername,
        applicationId: this.applicationId,
        fileName: this.fileName,
        documentId: this.documentId
      });
      openFileDialog(url, this.fileName);
      this.downloading = false;
    },
    toggleRenameDocument(edit) {
      this.editingFileName = edit != null ? edit : !this.editingFileName;
      if (this.editingFileName) {
        this.localFileName = this.fileNameWithoutExtension;
      }
    },
    async handleDeleteDocument() {
      this.deleting = true;
      await this.DELETE_DOCUMENT_FROM_REQUEST_CLASSIFICATION({
        documentId: this.documentId,
        documentRequestId: this.documentRequestId
      });
      this.deleting = false;
    },
    async handlePreviewClick() {
      this.loadingPreview = true;
      const {
        url
      } = await this.DOWNLOAD_DOCUMENT({
        clientUsername: this.clientUsername,
        applicationId: this.applicationId,
        fileName: this.fileName,
        documentId: this.documentId
      });
      this.previewDocumentUrl = url;
      this.showPreviewDocumentModal();
      this.loadingPreview = false;
    },
    showPreviewDocumentModal() {
      this.$refs.previewDocumentModal.$showModal();
    },
    handlePreviewDocumentModalHide() {
      this.previewDocumentUrl = "";
    },
    async handleEditDocument() {
      this.toggleRenameDocument(false);
      const fileName = `${this.localFileName}.${this.fileExtension}`;
      await this.RENAME_REQUEST_LIST_DOCUMENT({
        documentId: this.documentId,
        fileName
      });
    }
  })
});